import { AfterViewInit, Input, Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Component, EventEmitter } from '@angular/core';
import { MiniBtnConfig } from '../../../model';

/**
 * * Componente do mini botão do Apolo (apenas ícone).
 */
@Component({
  selector: 'ui-mini-btn',
  templateUrl: './mini-btn.component.html',
  styleUrls: ['./mini-btn.component.scss']
})
export class MiniBtnComponent implements AfterViewInit {

  /**
   * * Configuração do botão.
   */
  @Input() btn: MiniBtnConfig | undefined;

  @ViewChild('mini', { static: false }) mini: ElementRef<HTMLDivElement> | undefined;

  /**
   * * Evento do clique do botão.
   */
  @Output() btnEvent = new EventEmitter<any>();

  constructor() { }

  ngAfterViewInit(): void {
    const btnBox = this.mini?.nativeElement;
    if (btnBox) {
      this.setMargin(btnBox);
    }
  }

  callBtnEvent(event: MouseEvent): void {
    if (!this.btn?.disabled)
      this.btnEvent.emit(event);
  }

  private setMargin(btnBox: HTMLDivElement): void {
    if (this.btn?.marginRight) {
      btnBox.style.marginRight = '5px';
    }
  }
}
